import { useState } from "react";
import { BASE_URL } from "../../../config/apiConfig";
import { amountFieldLabelsToConvertInCrores, amountFieldLabelsToConvertToWords } from "../../../config/incentiveClaimFormUtils";
import { formatKeyNames, numberToWords, numberToWordsCrore } from "../../../utils/utils";
import TableView from "./TableView";

const KeyValueGrid = ({
  data,
  cols = "md:grid-cols-2",
  incentiveClaimId = null,
  language = false,
}) => {
  return (
    <div className={`grid grid-cols-1 ${cols} gap-x-6 gap-y-6`}>
      {Object.entries(data).map(([key, value]) => {
        const showInWords = amountFieldLabelsToConvertToWords.includes(key) && value && !isNaN(value) && Number(value) > 0;
        const showInCrores = amountFieldLabelsToConvertInCrores.includes(key) && value && !isNaN(value) && Number(value) > 0;
        const wordValue = showInWords && value ? numberToWords(value) : null;
        const croresValue = showInCrores && value ? numberToWordsCrore(value) : null;

        if (
          Array.isArray(value) &&
          value.length > 0 &&
          typeof value[0] === "object"
        ) {
          // 🔹 Render arrays of objects as a full-width table
          return <TableView label={key} value={value} language={language} />;
        }

        // 🔹 Render normal key/value pairs
        return (
          <div key={key}>
            <p>
              <strong>{formatKeyNames(key)} :</strong>
            </p>
            <span>{value || "--"}</span>
            {wordValue && (
              <p className="text-sm text-theme-color mt-1">
                {language ? wordValue.hi : wordValue.en}
              </p>
            )}
            {croresValue && (
              <p className="text-sm text-theme-color mt-1">
                {language ? croresValue.hi : croresValue.en}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KeyValueGrid;
